import { render, staticRenderFns } from "./input.vue?vue&type=template&id=5f566288"
import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"
import style0 from "./input.vue?vue&type=style&index=0&id=5f566288&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports